import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';
import {
  TransitTaskCarCategoryLimitsEntryFormComponent
} from '@zaoblako/web/modules/client/dumbs/transit-task-car-category-limits-form/entry/transit-task-car-category-limits-entry-form.component';
import type {
  TransitTaskCarCategoryLimitFormInterface
} from '@zaoblako/shared/modules/client/dtos/transit-task-car-category-limit/transit-task-car-category-limit-form.dto';

import { countBy } from 'lodash';
import {
  viewChildren,
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef
} from '@angular/core';

@Component({
  standalone: true,
  selector: 'crm-transit-task-car-category-limits-form',
  templateUrl: './transit-task-car-category-limits-form.component.html',
  styleUrl: './transit-task-car-category-limits-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    TransitTaskCarCategoryLimitsEntryFormComponent
  ]
})
export class TransitTaskCarCategoryLimitsFormComponent {
  @Input() public values: TransitTaskCarCategoryLimitFormInterface[] = [];
  @Output() public valuesChange = new EventEmitter<TransitTaskCarCategoryLimitFormInterface[]>();

  private readonly valuesForms = viewChildren(TransitTaskCarCategoryLimitsEntryFormComponent);

  public constructor(
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  /**
   * Validate values
   *
   * @returns Validation result
   */
  public validate(): boolean {
    const countByCategoryIds: Record<number, number> = countBy(
      (this.values || []).filter((value) => value.category?.id),
      (value) => value.category.id
    );

    const valuesForms = this.valuesForms();
    const valuesFormsResults = valuesForms.map((form) => form.validate(countByCategoryIds));
    return valuesFormsResults.every((isValid) => isValid);
  }

  /** Add value button click handler */
  public onAddValue() {
    this.values = this.values || [];
    this.values.push({
      category: null,
      limit: 1
    });

    this.valuesChange.emit(this.values);
    this.changeDetectorRef.markForCheck();
  }

  /**
   * Delete value button click handler
   *
   * @param indexToDelete Value index
   */
  public onDeleteValue(indexToDelete: number) {
    this.values = (this.values || []).filter((_, index) => index !== indexToDelete);
    this.valuesChange.emit(this.values);
    this.changeDetectorRef.markForCheck();
  }
}
